import { createAsyncThunk } from '@reduxjs/toolkit';
import * as brandApi from '../../utils/api/brandApi';

// Fetch all brands
export const fetchBrands = createAsyncThunk(
  'brand/fetchBrands',
  async (_, { rejectWithValue }) => {
    try {
      const response = await brandApi.fetchBrands();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
